import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell
} from 'recharts';
import "./App.css";
import logoSvant from "./img/svant-logo.svg";

export default function Dashboard() {
  const [data, setData] = useState([]);
  const [totalCo2, setTotalCo2] = useState(0);
  const [perCapita, setPerCapita] = useState(0);
  const [registros, setRegistros] = useState(0);              
  const [participacion, setParticipacion] = useState(0);      
  const navigate = useNavigate();

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000';

  useEffect(() => {
    const fetchVisual = () => {
      fetch(`${BACKEND_URL}/visual-data`)
        .then((res) => res.json())
        .then((r) => {
          setData(r.data || []);
          setRegistros(r.registrosTotales ?? 0);               
          setParticipacion(r.participacionPorcentaje ?? 0);    
          setTotalCo2(r.emisionesTotales ?? 0);
          setPerCapita(r.estimativoPercapita ?? 0);
        })
        .catch((err) => console.error("Error al obtener datos:", err));
    };

    fetchVisual();
    const id = setInterval(fetchVisual, 10000);
    return () => clearInterval(id);
  }, [BACKEND_URL]);

  const getChartData = (arr, names) =>
    (arr || [])
      .filter(item => names.includes(item.name))
      .sort((a, b) => b.KgCO2e - a.KgCO2e);

  const fixedNames   = ['Energía eléctrica', 'Consumo gas', 'Logística'];
  const dynamicNames = ['Traslado aéreo', 'Traslado terrestre', 'Hotelería'];

  const chartFixed   = getChartData(data, fixedNames);
  const chartDynamic = getChartData(data, dynamicNames);

  const handlePrint = () => window.print();

  return (
    <div className='container'>
      <div className='containerFlex'>
        <div className='card flexBetween printHeader'>
          <img className='logoSvant' src={logoSvant} alt="Svant Measure and Act" />
          <div>
            <button className='btnPrint' onClick={handlePrint}>Imprimir</button>
            <button onClick={() => navigate('/')}>Agregar registros</button>
          </div>
        </div>
      </div>

      <div className='containerFlex'>
        <div className='card printData'>
          <h2>Emisión total del evento:</h2>
          <div className='totalEmission'>{Number(totalCo2).toFixed(2)} Kg CO₂e</div>
        </div>
        <div className='card printData'>
          <h2>Estimativo per capita</h2>
          <div className='totalEmission'>{Number(perCapita).toFixed(2)} Kg CO₂e</div>
        </div>
      </div>

      <div className='containerFlex'>
        <div className='card printData'>
          <h2>Cantidad de registros</h2>
          <div className='totalEmission'>{registros}</div>
        </div>
        <div className='card printData'>
          <h2>Porcentaje de participación</h2>
          <div className='totalEmission'>{Number(participacion).toFixed(2)} %</div>
        </div>
      </div>

      <div className='containerFlex'>
        <div className='card'>
          <h2>Emisiones fijas del evento</h2>
          <ResponsiveContainer width="100%" height={270}>
            <BarChart layout="vertical" data={chartFixed} margin={{ top: 0, right: 5, left: 35, bottom: 0 }} barSize={50}>
              <CartesianGrid strokeDasharray="2 2" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" />
              <Tooltip />
              <Legend />
              <Bar dataKey="KgCO2e" radius={[0, 5, 5, 0]} legendType="none">
                <Cell fill="#235B67" /><Cell fill="#227E79" /><Cell fill="#23A487" />
                <Cell fill="#23C998" /><Cell fill="#70D460" /><Cell fill="#A3C854" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className='card'>
          <h2>Emisiones móviles del evento</h2>
          <ResponsiveContainer width="100%" height={270}>
            <BarChart layout="vertical" data={chartDynamic} margin={{ top: 0, right: 5, left: 35, bottom: 0 }} barSize={50}>
              <CartesianGrid strokeDasharray="2 2" />
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" />
              <Tooltip />
              <Legend />
              <Bar dataKey="KgCO2e" radius={[0, 5, 5, 0]} legendType="none">
                <Cell fill="#235B67" /><Cell fill="#227E79" /><Cell fill="#23A487" />
                <Cell fill="#23C998" /><Cell fill="#70D460" /><Cell fill="#A3C854" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <h4 className='printTitle'>Reporte generado para</h4>
      <h4 className='printTitle'><b>Unlock Event</b></h4>
    </div>
  );
}
